export const BASE_HOST = (process.env.REQ_HOST ||
    `${window.location.protocol}//${window.location.host}`);
export const BASE_PATH = BASE_HOST + "/api";
